import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  excelUploadProblems: [],
  excelUploadError: "",
};

export default function ExcelUploadReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_EXCEL_UPLOAD:
      return { ...state, loading: action.payload };
    case actions.EXCEL_UPLOAD_FAIL:
      return { ...state, excelUploadError: action.payload };
    case actions.EXCEL_UPLOAD_PROBLEMS:
      return { ...state, excelUploadProblems: action.payload };
    default:
      return state;
  }
}
